import axios from 'axios';

const BASE_URL=process.env.REACT_APP_BASE_URL;

export const axiosInstance = axios.create({
  withCredentials: true,
  baseURL: `${BASE_URL}/api`,
  //timeout: 10000, // Increase timeout to 10 seconds
  headers: {
    "Content-Type": "application/json",
  },
});

export const axiosInstanceForImage = axios.create({
  withCredentials: true,
  baseURL: `${BASE_URL}/api`,
  responseType: 'blob',
  headers: {
    "Content-Type": "multipart/form-data",
  },
});